import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import PropTypes from 'prop-types';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    Typography,
    withStyles,
} from "@material-ui/core";
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import BuildIcon from '@material-ui/icons/Build';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import {KeyboardDatePicker} from "@material-ui/pickers";
import moment from "moment";

import CancelAcceptForm from "../../../../Common/CancelAcceptForm";
import t from "../../../../../languages/pl";
import {buttonStyle} from "../buttonGroupStyle";
import {themeTypeToBool} from '../../../../../utils/helpers';
import {compose} from 'recompose';
import withSubordinateUser from './../../../../HOC/withSubordinateUser';

import {deleteInspection, postNewInspection, updateInspection} from "../../../../../store/actions/carsAction";
import {displayDateFormat} from "../../../../../utils/staticData";


const useStyles = theme => ({
    button: buttonStyle(theme),
    container: {
        margin: theme.spacing(1),
        marginLeft: theme.spacing(3)
    },
    row: {
        display: "flex",
        alignItems: "center",
        marginBottom: 24
    },
    textLabel: {
        width: 240
    },
    timePicker: {
        marginLeft: theme.spacing(2)
    },
    textfield: {
        marginLeft: theme.spacing(1)
    },

    labelField: {
        fontWeight: "bold"
    },


    mileage: {
        marginTop: 8,
        marginLeft: theme.spacing(1)
    },

    details: {
        width: 362,
        marginLeft: theme.spacing(1)
    },

    description: {
        display: "inline-block",
        width: 360,
        color: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
    },

    listDetails: {
        maxHeight: 400,
        overflowY: "auto",
    },

    label: {
        color: themeTypeToBool(theme.palette.type) ? "#000" : "#FAFAFA"
    }
});


function FolderList(props) {
    const {classes, theme} = props;
    const dispatch = useDispatch();
    const selectedCar = useSelector((state) => state.carsReducer.selectedCar);
    const {przeglady_serwisowe} = useSelector((state) => state.carsReducer.inspections.history);

    const [inspections, setInspections] = useState([]);
    const [id, setId] = useState();
    const [opis, setOpis] = useState("");
    const [dystans, setDystans] = useState(selectedCar.dystans);
    const [data, setData] = useState(moment().unix());


    useEffect(() => {
        if (przeglady_serwisowe && przeglady_serwisowe.length > 0) {
            setInspections(przeglady_serwisowe.sort((a, b) => b.data > a.data ? 1 : -1));
        }
    }, [przeglady_serwisowe]);

    const onSubmit = (event) => {
        event.preventDefault();
        if (id) {
            dispatch(updateInspection({
                przeglad_id: id,
                dystans: dystans,
                opis: opis,
                data: data * 1000
            }));
        } else {
            dispatch(postNewInspection({
                samochod_id: selectedCar.auto_id,
                dystans: dystans,
                opis: opis,
                data: data * 1000
            }));
        }
        setId(null);
        setOpis("");
        setDystans(selectedCar.dystans);
        setData(moment().unix());
    };

    const onEdit = (inspection) => {
        setId(inspection.przeglad_id);
        setOpis(inspection.opis);
        setDystans(inspection.dystans);
        setData(inspection.data);
    };

    const onDelete = (event, inspection) => {
        event.preventDefault();
        dispatch(deleteInspection(inspection.przeglad_id));
    };

    const onSetOpis = (event) => {
        setOpis(event.target.value);
    };
    const onSetDystans = (event) => {
        setDystans(event.target.value);
    };

    const onSetData = (data) => {
        setData(moment(data).unix());
    };

    return (
        <>
            <form onSubmit={onSubmit} className={classes.container}>

                <div className={classes.row}>
                    <TextField
                        label={t.mileage + " km"}
                        className={classes.mileage}
                        InputLabelProps={{
                            classes: {root: classes.label}
                        }}
                        style={{paddingBottom: theme.spacing(3)}}
                        value={dystans}
                        onChange={onSetDystans}
                    />

                    <KeyboardDatePicker
                        className={classes.timePicker}
                        variant="inline"
                        format="DD-MM-YYYY"
                        invalidDateMessage={t.invalidDateFormat}
                        value={moment.unix(data).format("YYYY-MM-DD")}
                        onChange={onSetData}
                    />
                </div>

                <TextField
                    label={t.description}
                    className={classes.details}
                    multiline
                    InputLabelProps={{
                        classes: {root: classes.label}
                    }}
                    style={{paddingBottom: theme.spacing(2)}}
                    value={opis}
                    onChange={onSetOpis}
                />


                <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    value="submit"
                    disabled={!opis}
                    style={{marginBottom: theme.spacing(2), marginLeft: theme.spacing(2)}}>
                    {id ? t.save : t.add}
                </Button>

            </form>

            <Typography variant="subtitle1">
                {t.technicalInspections}:
            </Typography>

            <List className={classes.listDetails}>
                {inspections
                    .map(inspection =>
                        <ListItem key={inspection.przeglad_id}>
                            <ListItemAvatar>
                                <Avatar>
                                    <BuildIcon/>
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={inspection.dystans + " km"}
                                secondary={
                                    <React.Fragment>
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            className={classes.description}
                                        >
                                            {inspection.opis}
                                        </Typography>
                                        <br/>
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            className={classes.label}
                                        >
                                            {moment.unix(inspection.data).format(displayDateFormat)}
                                        </Typography>

                                    </React.Fragment>
                                }/>
                            <ListItemSecondaryAction>
                                <IconButton edge="end" aria-label="edit" onClick={() => onEdit(inspection)}>
                                    <EditIcon/>
                                </IconButton>
                                <IconButton edge="end" aria-label="delete"
                                            onClick={($event) => onDelete($event, inspection)}>
                                    <DeleteIcon/>
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    )}
            </List>
        </>
    );
}

FolderList.propTypes = {
    classes: PropTypes.object,
    theme: PropTypes.object,
};


function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};


const Inspection = props => {
    const {classes, theme, name, data: input, onDialogOpen, onSubmit, onResetServiceRemainders, nonAdminUser} = props;
    const [open, setOpen] = useState(false);
    const [data, setData] = useState(input);
    const [value, setValue] = React.useState(0);

    useEffect(() => {
        setData(input);
    }, [input]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleStartTimeChange = (e) => {
        setData({
            ...data,
            technical: {
                ...data.technical,
                data_przegladu: moment(e).unix(),
            }
        });
    };

    const handleSetServiceTimeChange = (e) => {
        setData({
            ...data,
            service: {
                ...data.service,
                przeglad_data: moment(e).unix(),
            }
        });
    };

    const handleDialogOpen = () => {
        setOpen(true);
        if (onDialogOpen)
            onDialogOpen();
    };

    const handleSubmit = () => {
        setOpen(false);
        if (onSubmit)
            onSubmit(data);
    };

    const handleResetServiceRemainders = () => {
        setOpen(false);
        if (onResetServiceRemainders)
            onResetServiceRemainders(data);
    };

    return (
        <React.Fragment>
            <Button
                variant="outlined"
                className={classes.button}
                onClick={handleDialogOpen}
            >
                {t.inspections}
            </Button>

            <Dialog
                open={open}
                fullWidth={true}
                maxWidth="sm"
                onClose={() => setOpen(false)}
            >

                <DialogTitle>{name}</DialogTitle>

                <DialogContent>

                    <Tabs
                        value={value}
                        indicatorColor="primary"
                        onChange={handleChange}
                        aria-label="inspections settings"
                    >
                        <Tab label={t.settings}/>
                        <Tab label={t.inspections}/>
                    </Tabs>

                    <div>

                        <TabPanel value={value} index={0} dir={theme.direction}>
                            <div>
                                <Typography
                                    variant="subtitle1"
                                    style={{marginBottom: theme.spacing(2)}}>
                                    {t.technicalInspections}:
                                </Typography>
                            </div>
                            <div className={classes.container}>
                                <div className={classes.row}>
                                    <Typography
                                        variant="body1"
                                        className={classes.textLabel}
                                    >
                                        {t.nextInspectionDate}:
                                    </Typography>
                                    <KeyboardDatePicker
                                        className={classes.timePicker}
                                        variant="inline"
                                        format="DD-MM-YYYY"
                                        invalidDateMessage={t.invalidDateFormat}
                                        value={data.technical.data_przegladu === 0 ? null : moment.unix(data.technical.data_przegladu).format("YYYY-MM-DD")}
                                        onChange={handleStartTimeChange}
                                    />
                                </div>
                            </div>

                            <div>
                                <Typography
                                    variant="subtitle1"
                                    style={{marginBottom: theme.spacing(2), paddingTop: "2rem"}}>
                                    {t.serviceInspections}:
                                </Typography>
                            </div>

                            <div className={classes.container}>
                                <div className={classes.row}>
                                    <Typography
                                        variant="body1"
                                        className={classes.textLabel}
                                    >
                                        {t.serviceDateRemider}:
                                    </Typography>
                                    <KeyboardDatePicker
                                        className={classes.timePicker}
                                        variant="inline"
                                        format="DD-MM-YYYY"
                                        invalidDateMessage={t.invalidDateFormat}
                                        value={data.service.przeglad_data === 0 ? null : moment.unix(data.service.przeglad_data).format("YYYY-MM-DD")}
                                        onChange={handleSetServiceTimeChange}
                                    />
                                </div>
                            </div>

                            <div className={classes.container}>
                                <div className={classes.row}>
                                    <Typography
                                        variant="body1"
                                        className={classes.textLabel}
                                    >
                                        {t.serviceRemider}
                                    </Typography>
                                    <TextField
                                        label={t.kilometers}
                                        className={classes.textfield}
                                        InputLabelProps={{
                                            classes: {root: classes.label}
                                        }}
                                        FormHelperTextProps={{
                                            classes: {root: classes.label}
                                        }}
                                        helperText={t.makingChangeResetsReminderCounter}
                                        value={data.service.przeglad_co}
                                        onChange={(e) => setData({
                                            ...data,
                                            service: {...data.service, przeglad_co: e.target.value}
                                        })}
                                    />
                                </div>

                                <div className={classes.row}>
                                    <Typography
                                        variant="body1"
                                        className={classes.textLabel}>
                                        {t.reminderMaxBefore}
                                    </Typography>
                                    <TextField
                                        label={t.kilometers}
                                        className={classes.textfield}
                                        InputLabelProps={{
                                            classes: {root: classes.label}
                                        }}
                                        style={{paddingBottom: theme.spacing(3)}}
                                        value={data.service.informacja_przed}
                                        onChange={(e) => setData({
                                            ...data,
                                            service: {...data.service, informacja_przed: e.target.value}
                                        })}
                                    />
                                </div>
                                <div className={classes.row}>
                                    <Typography
                                        variant="body1"
                                        className={classes.textLabel}>
                                        {t.reminderMaxAfter}
                                    </Typography>
                                    <TextField
                                        label={t.kilometers}
                                        className={classes.textfield}
                                        InputLabelProps={{
                                            classes: {root: classes.label}
                                        }}
                                        style={{paddingBottom: theme.spacing(3)}}
                                        value={data.service.informacja_po}
                                        onChange={(e) => setData({
                                            ...data,
                                            service: {...data.service, informacja_po: e.target.value}
                                        })}
                                    />
                                </div>

                                <div className={classes.row}>

                                    <Typography
                                        variant="body1"
                                        className={classes.labelField}>
                                        {t.nearestServiceRemiderWhen} {data.service.najblizsze_przypomnienie} km przy
                                        przebiegu {data.service.najblizsze_przypomnienie_dystans} km
                                    </Typography>

                                </div>

                            </div>
                        </TabPanel>

                        <TabPanel value={value} index={1} dir={theme.direction}>
                            <FolderList theme={theme} classes={classes}/>
                        </TabPanel>
                    </div>

                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={handleResetServiceRemainders}
                        color="primary"
                    >
                        {'Reset Przypomnień'}
                    </Button>
                    <CancelAcceptForm
                        onCancel={() => setOpen(false)}
                        onSubmit={handleSubmit}
                        disableSubmit={nonAdminUser}
                    />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};

Inspection.propTypes = {
    classes: PropTypes.object,
    theme: PropTypes.object,
    name: PropTypes.string,
    data: PropTypes.object,
    onDialogOpen: PropTypes.func,
    onSubmit: PropTypes.func,
    onResetServiceRemainders: PropTypes.func,
    //withSubordinateUser
    nonAdminUser: PropTypes.bool
};

export default compose(
    withStyles(useStyles, {withTheme: true}),
    withSubordinateUser
)(Inspection);
